import { configureStore } from '@reduxjs/toolkit'

import app from './appSlice';
import membership from './membershipSlice';
import request from './requestSlice';

export const store = configureStore({
  reducer: {
    app: app,
    membership: membership,
    request: request
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch